import { render, staticRenderFns } from "./Course-details.vue?vue&type=template&id=17d83182&scoped=true"
import script from "./Course-details.vue?vue&type=script&lang=js"
export * from "./Course-details.vue?vue&type=script&lang=js"
import style0 from "./Course-details.vue?vue&type=style&index=0&id=17d83182&prod&scoped=true&lang=css"
import style1 from "./Course-details.vue?vue&type=style&index=1&id=17d83182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d83182",
  null
  
)

export default component.exports